import { Vue } from 'vue-property-decorator';
import KeyboardManager from '../../util/keyboardManager.js';

export default class KeyListenerView extends Vue {
    
    addKeyboardListener(key, handler, label) {
        this._keyboardListeners = this._keyboardListeners || {};
        this._keyboardListeners[key] = {
            label, handler, alt: key.startsWith('ALT')
        };
    }

    getKeyboardListeners() {
        return this._keyboardListeners;
    }
    
    mounted() {
        KeyboardManager.pushView(this);
    }
    
    destroyed() {
        KeyboardManager.popView(this);
    }
}
